import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfPotreroHillOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'potrero-hill',
  neighborhoodDisplayName: 'Potrero Hill',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 1,
  whereFromStreetsToLandmark:
    'from the buildings along 18th St, Connecticut St, and De Haro St to the clusters near the Central Waterfront',
  whereTeamStreets: '18th St, Connecticut St, De Haro St, 22nd St',
  clientDescriptor: 'a small team tech startup near 18th St',
  counts: {
    managedCleaningOffices: 1,
    managedPantryOffices: 1,
    managedInternetOffices: 1,
    managedFurnitureOffices: 1,
    managedOfficeAssistantOffices: 1,
    managedDeepCleaningOffices: 1,
    managedCarpetCleaningOffices: 1,
    managedWindowCleaningOffices: 1,
    managedGlassCleaningOffices: 1,
    managedWasteRecyclingOffices: 1,
    managedPantryInventoryOffices: 1,
    managedCoffeeServiceOffices: 1,
    managedWaterServiceOffices: 1,
    managedTeamLunchOffices: 1,
    managedBreakfastCateringOffices: 1,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 1,
    managedHappyHourOffices: 1,
    managedConferenceRoomAvOffices: 1,
    managedNetworkInstallationOffices: 1,
    managedNetworkManagementOffices: 1,
    managedCableManagementOffices: 1,
    managedRoomBookingOffices: 1,
    managedPrintingSetupOffices: 1,
    managedInteriorDesignOffices: 1,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 1,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 1,
    managedLayoutChangeOffices: 1,
    managedOfficePlantsOffices: 1,
    managedKeylessAccessOffices: 1,
    managedAlarmSystemsOffices: 1,
    managedSecurityCamerasOffices: 1,
    managedKeypadOffices: 1,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 1,
    managedBusinessInsuranceOffices: 1,
    managedElectricalServicesOffices: 2,
    managedHvacOffices: 2,
    managedPlumbingOffices: 2,
    managedPestControlOffices: 1,
    managedOfficeMovingOffices: 2,
    managedMountingInstallationOffices: 3
  },
  quotes: {
    cleaning: 'We needed cleaning, pantry, and someone to coordinate vendors. Codi handles all of it.',
    pantryRestocking: 'The pantry was always running out. Since Codi took it over, it just stays stocked.',
    internet: 'Codi coordinated the vendor walkthrough and the whole install \u2014 we just showed up.',
    officeAssistant: "Codi's on-site person handles all the little things so the team can focus.",
    officeFurniture: 'We had a whole furniture order and no one to coordinate it. Codi handled everything.',
    deepCleaning: 'Bi-annual deep cleans are part of our lease requirements. Codi schedules and coordinates them.',
    carpetCleaning: 'Older Potrero Hill building, carpet needed professional attention. Codi handled the whole thing.',
    windowCleaning:
      'Industrial windows in our converted warehouse space need regular cleaning. Codi runs the schedule.',
    glassConferenceRoom: 'Glass partition walls look great when they\u2019re clean. Codi keeps them that way.',
    wasteRecycling: 'Codi set up our recycling system from day one. It just works.',
    pantryInventory: 'We\u2019re a lean team \u2014 nobody has time to manage pantry stock. Codi automates all of it.',
    coffeeService:
      'Potrero Hill startup culture means quality coffee is expected. Codi keeps the machine running and stocked.',
    waterService: 'Filtered water was always an issue. Codi set up the dispenser and refills it on schedule.',
    teamLunch: 'Team lunch in Potrero Hill is a weekly ritual. Codi finds the caterer and handles the delivery.',
    breakfastCatering:
      'We bring the team together Thursday mornings. Codi handles the food so we can focus on the standup.',
    individualMeals:
      'Daily lunch program for the team. Codi manages the order, delivery, and vendor so we don\u2019t have to.',
    adHocCatering:
      'Customer visits, investor drop-ins \u2014 Codi always has catering ready without advance planning from us.',
    happyHour: 'Friday happy hour on the roof. Codi handles the drinks order and setup every week.',
    conferenceRoomAv: 'Converted warehouse space, no A/V infrastructure at all. Codi built it out from scratch.',
    networkInstallation: 'New lease, new network. Codi had structured cabling and managed wifi running on day one.',
    networkManagement:
      'Codi monitors and manages our network remotely. We haven\u2019t had a real outage since they took over.',
    cableManagement: 'Potrero Hill studio vibe \u2014 Codi ran clean overhead cable trays so the space looks the part.',
    roomBooking:
      'We share conference rooms with another tenant. Codi deployed a booking system that works for both teams.',
    printingSetup:
      'Codi installed and configured our office printers. Same-day fix every time something needs attention.',
    interiorDesign:
      'Converted warehouse space needed a real design pass. Codi planned the layout and managed the full fit-out.',
    officeMurals:
      'Potrero Hill vibe called for a mural in the main workspace. Codi sourced a local artist and coordinated the whole thing.',
    officePainting:
      'Industrial walls needed color before the team moved in. Codi ran the painters overnight and it was done.',
    glassFrosting: 'Privacy film on the manager offices. Codi came in, measured, and installed it in a couple hours.',
    officeSignage:
      'We wanted signage that matched the converted-warehouse aesthetic. Codi found fabricators who nailed it.',
    careRoom:
      'Carved out a private room near the back. Codi furnished it and added the privacy setup in one appointment.',
    furnitureAssembly:
      'New desks and chairs for the full team. Codi sent a crew and had it all done before the first day.',
    layoutChange: 'Team doubled and the layout needed to change. Codi reconfigured the floor over a long weekend.',
    officePlants:
      'Warehouse-style space with high ceilings. Codi brought in large plants that fill the space right and maintains them monthly.',
    keylessAccess:
      'Converted warehouse in Potrero Hill \u2014 we needed keyless access before the team moved in. Codi handled installation and credential setup.',
    alarmSystems:
      'Ground-floor warehouse space needed a monitored alarm. Codi sourced the vendor and manages ongoing testing.',
    securityCameras:
      'Multiple entry points in the warehouse needed camera coverage. Codi installed and manages the full system.',
    keypads: 'Potrero Hill studio has two entry doors. Codi installed keypads and manages access codes for both.',
    lockboxes:
      'After-hours vendor access is common here. Codi manages the lockbox and coordinates access so we don\u2019t have to.',
    visitorManagement:
      'We host client visits and partner days. Codi set up a visitor check-in system that keeps things professional.',
    businessInsurance:
      'Landlord requires current COI on file at all times. Codi manages the policy and handles certificate requests.',
    electricalServices:
      'Converted warehouse needed significant electrical work before occupancy. Codi managed licensed electricians and permit coordination with the building.',
    hvac: 'High ceilings in the warehouse space made HVAC a real challenge. Codi found a specialist vendor and manages the maintenance schedule.',
    plumbing:
      'Older Potrero Hill building had aging plumbing. Codi manages preventive maintenance and handles any repairs quickly.',
    pestControl:
      'Ground-floor warehouse space in Potrero Hill. Codi schedules quarterly pest control and manages building compliance documentation.',
    officeMoving:
      'Moving a creative team\u2019s studio means protecting a lot of equipment. Codi coordinated the mover, the building access, and the full setup.',
    mountingInstallation:
      'High warehouse walls needed proper anchoring for displays and artwork. Codi managed the installation crew and got it right the first time.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
